<template>
    <div class="tsa-TsaDialog" v-show="show" @touchmove.prevent>
        <div class="mask"></div>
        <div class="tsa-TsaDialog-content">
            <div class="tsa-TsaDialog-content-title">
                <p>提示</p>
            </div>
            <div class="content">
                <p v-html="message"></p>
            </div>
            <div class="btnGroup">
                <p class="cancel" @click="cancel">
                    <span>取消</span>
                </p>
                <p class="confirm" @click="confirm">
                    <span>{{ confirmBtnText }}</span>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'tsa-TsaDialog',
        data () {
            return {
                show: false,
                message: '123',
                statusConfirm: 0,
                statusCancel: 0,
                confirmBtnText: ''
            }
        },
        methods: {
            cancel() {
                this.statusCancel++
            },
            confirm () {
                this.statusConfirm++
            }
        }
    }
</script>
<style scoped>
    .tsa-TsaDialog {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 10;
    }
    .mask {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.6)
    }
    .tsa-TsaDialog-content {
        position: absolute;
        width: 85%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        display: flex;
        flex-direction: column;
        border-radius: 4px;
        position: fixed;
        border-radius: 3px;
        font-size: 16px;
        -webkit-user-select: none;
        overflow: hidden;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        -webkit-transition: .2s;
        transition: .2s;
    }
    .tsa-TsaDialog-content-title {
        padding: 15px 0 0;
       
    }
    .tsa-TsaDialog-content-title p {
        text-align: center;
        padding-left: 0;
        margin-bottom: 0;
        font-size: 16px;
        font-weight: 700;
        color: #333;
    }
    .tsa-TsaDialog .tsa-TsaDialog-content .content {
        padding: 10px 20px 15px;
        border-bottom: 1px solid #ddd;
        min-height: 36px;
        position: relative;
        color: #999;
        margin: 0;
        text-align: center;
        line-height: 36px;
    }
    .btnGroup {
        display: flex;
        height: 40px;
        line-height: 40px;
    }
    .btnGroup p {
        line-height: normal;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .btnGroup p span {

    }
    .cancel {
        width: 50%;
        border-right: 1px solid #ddd;
    }
    .confirm {
        color: #26a2ff;
        width: 50%;
    }
</style>


// WEBPACK FOOTER //
// src/components/Dialog/index.vue